/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useRef } from "react";
import "./MobileMapLegend.scss";
import CaretDownIcon from "calcite-ui-icons-react/CaretDownIcon";
import Legend from "@arcgis/core/widgets/Legend";
import { MapContext } from "../../context/MapContext";
import { Drawer, makeStyles } from "@material-ui/core";

function MobileMapLegend(props) {
  const { viewLegendOpen, setViewLegendOpen, appDrawerExtended } = props
  const legendDiv = useRef(null);
  const [mapObject] = useContext(MapContext);

  useEffect(() => {
    if (legendDiv.current && mapObject?.view) {
      new Legend({
        container: legendDiv.current,
        view: mapObject.view,
      });
    }
  }, [legendDiv, mapObject?.view]);

  useEffect(() => {
    if (appDrawerExtended) {
      setViewLegendOpen(false);
    }
  }, [appDrawerExtended]);

  const useStyles = makeStyles(({
    legend: {
      position: 'fixed',
      bottom: '0',
      right: '0',
      left: 'auto',
    },
    legendPaper: {
      height: 'calc((100% - 55px)/2) ',
      position: 'fixed',
      zIndex: '1',
      ...(window.innerWidth > 450 && {
        left: 'auto',
        width: '350px',
      }),
      borderTop: 'none',
    },
    modal: {
      zIndex: '1',
    }
  }));

  const toggleLegend = () => {
    setViewLegendOpen(!viewLegendOpen);
  };

  const classes = useStyles();

  return (
    <Drawer
      variant="persistent"
      anchor="bottom"
      ModalProps={{ keepMounted: true }}
      style={{ inset: null, zIndex: '1' }}
      className={classes.legend}
      classes={
        {
          paper: classes.legendPaper,
          modal: classes.modal,
        }
      }
      open={viewLegendOpen}
      onClose={() => { setViewLegendOpen(false) }}
    >
      <div className="mobileMapLegend">
        <div className="legendHeader handle">
          <div className="legendTitle">Map Legend</div>
          <div onClick={toggleLegend} className="legendToggle">
            <CaretDownIcon />
          </div>
        </div>
        <div
          className="esriLegend"
          ref={legendDiv}
        />
      </div>
    </Drawer>
  );
}

export default MobileMapLegend;
